import vueDropzone from './components/vue-dropzone.vue'

export default vueDropzone
